import React from "react";
import { MoreHorizontal, Pencil, Trash2, Eye, MessageSquare } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

export function DataTable({ columns, rows, helpers, onEdit, onDelete, onView, onMessage, canWrite, emptyText = "データがありません", testid }) {
  const { t } = useI18n();
  const hasActions = onEdit || onDelete || onView || onMessage;
  return (
    <div className="border border-border bg-white rounded-sm overflow-hidden" data-testid={testid}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50 border-b border-border text-left">
              {columns.map((c) => (
                <th key={c.key} className="px-4 py-3 font-medium text-xs uppercase tracking-wider text-muted-foreground whitespace-nowrap">
                  {t(c.label)}
                </th>
              ))}
              {hasActions && <th className="px-4 py-3 w-12"></th>}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td colSpan={columns.length + (hasActions ? 1 : 0)} className="px-4 py-12 text-center text-muted-foreground">
                  {t(emptyText)}
                </td>
              </tr>
            )}
            {rows.map((row, i) => (
              <tr
                key={row.id || i}
                className="border-b border-border last:border-0 hover:bg-gray-50 transition-colors cursor-default"
                data-testid={`row-${testid}-${i}`}
                onClick={() => onView && onView(row)}
                style={onView ? { cursor: "pointer" } : {}}
              >
                {columns.map((c) => (
                  <td key={c.key} className="px-4 py-3 whitespace-nowrap align-middle">
                    {c.render ? c.render(row, helpers) : (row[c.key] ?? "-")}
                  </td>
                ))}
                {hasActions && (
                  <td className="px-4 py-3 text-right" onClick={(e) => e.stopPropagation()}>
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <button className="p-1.5 rounded-sm hover:bg-gray-200 transition-colors" data-testid={`action-${testid}-${i}`}>
                          <MoreHorizontal className="w-4 h-4" />
                        </button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end" className="w-36">
                        {onView && (
                          <DropdownMenuItem onClick={() => onView(row)} data-testid={`view-${testid}-${i}`}>
                            <Eye className="w-4 h-4 mr-2" />{t("詳細")}
                          </DropdownMenuItem>
                        )}
                        {onMessage && (
                          <DropdownMenuItem onClick={() => onMessage(row)} data-testid={`message-${testid}-${i}`}>
                            <MessageSquare className="w-4 h-4 mr-2" />{t("メッセージ")}
                          </DropdownMenuItem>
                        )}
                        {onEdit && canWrite && (
                          <DropdownMenuItem onClick={() => onEdit(row)} data-testid={`edit-${testid}-${i}`}>
                            <Pencil className="w-4 h-4 mr-2" />{t("編集")}
                          </DropdownMenuItem>
                        )}
                        {onDelete && canWrite && (
                          <DropdownMenuItem onClick={() => onDelete(row)} className="text-red-600" data-testid={`delete-${testid}-${i}`}>
                            <Trash2 className="w-4 h-4 mr-2" />{t("削除")}
                          </DropdownMenuItem>
                        )}
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
